import { MutationTree } from 'vuex';

import { RootStateI, AlertI, BusinessI } from './state';

const mutations: MutationTree<RootStateI> = {
  closeSidebar(state) {
    state.showSidebar = false;
  },
  toggleSidebar(state, payload?: boolean) {
    if (payload !== undefined) {
      state.showSidebar = payload;
    } else {
      state.showSidebar = !state.showSidebar;
    }
  },
  setAlert(state, payload: AlertI) {
    state.alert.message = payload.message;
    state.alert.type = payload.type;

    switch (payload.type) {
      case 'success':
        state.alert.color = 'green';
        break;
      case 'error':
        state.alert.color = 'red';
        break;
      case 'warning':
        state.alert.color = 'yellow';
        break;
      default:
        state.alert.color = 'blue';
    }
  },
  clearAlert(state) {
    state.alert.message = '';
    state.alert.type = '';
    state.alert.color = '';
  },
  setBusiness(state, payload: BusinessI) {
    state.business = payload;
    localStorage.setItem('business', JSON.stringify(payload));
  },
};

export default mutations;
